<template>
	<div>
		<v-card class="pa-0">
		<v-card-text>
			<!-- <v-divider></v-divider> -->
			<v-item-group v-model="infoToFilter.tagsSelected" multiple>
				<v-container fluid class="pt-0 overflow-y-auto">
					<v-row dense class="fill-height" style="max-height: 300px;">
						<v-col 
							v-for  	= "(item_face, idx_face) of infoToFilter.tags" 
							:key 	= "'list_faces_sidebar' + idx_face" 
							cols 	= "auto"  
							class = "mb-3"
						>
							<!-- @click 	="sel(n)"  -->
							<v-item v-slot:default = "{ active, toggle }" :value="item_face">
								<v-card 
									dark  
									outlined
									:color 	= "active  ? 'primary' : item_face.isValid ? 'success': item_face.isInvalid ? 'error': '' "  
									style 	= "width:100px; height: 100%;"  
									class 	= "pl-0 ma-0" 
								>	
									<!-- <v-card-title class = "pa-0 ma-0 secodary justify-center" style = "font-size: 70%; line-height: 110%"> -->
										<!-- <v-spacer></v-spacer> -->
										
									<!-- </v-card-title>																		 -->
									<v-img  												                 		
										contain
										@click 	= "toggle" 
										:src   = "$Helper.check_img(item_face.imgBase64, $URL)" 
										@error = "item_face.imgBase64 = '/img/no_img_found.png'"
										width  = "100%" 
										:height = "'100%'"
										:lazy-src="$logos.mark || ($vuetify.theme.dark ? $logos.login_night : $logos.login)"
										:aspect-ratio="16/9"
										
									>
										<v-tooltip top>
											<template v-slot:activator = "{ on }">
												<v-btn
													fab												
													color   = "error"
													@click  = "deleteFaceItem(item_face)"
													width   = "20"
													height  = "20" 

													v-on 	= "on"
												>
													<v-icon small color="white"> mdi-delete </v-icon>
												</v-btn>
											</template>
											<span> {{ $ml.get('delete') }} </span>		
										</v-tooltip>

										<!-- Badge para indicar si la cara está entrenada -->
										<template v-slot:placeholder>
											<v-row class="fill-height ma-0" align="center" justify="center">
												<v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
											</v-row>
										</template>
									</v-img>

									<!-- Badge de entrenamiento -->
									<v-fade-transition>
										<v-chip
											v-if="item_face.isTrained"
											small
											color="success"
											text-color="white"
											class="ma-1"
											style="position: absolute; top: 5px; right: 5px; z-index: 10;"
										>
											<v-icon left x-small>mdi-brain</v-icon>
											Trained
										</v-chip>
									</v-fade-transition>			
							            <v-card-actions style = "font-size: 80%; line-height: 110%">
							            	<span> {{ item_face.name }}</span><br>
							            	<!-- {{ $ml.get('face') }} : idx_face + 1 -->
											<span> {{ item_face.msg }}</span>
											<!-- Mostrar información de entrenamiento si está disponible -->
											<v-expand-transition>
												<div v-if="item_face.isTrained" class="mt-1">
													<v-chip
														x-small
														color="success"
														text-color="white"
														class="mt-1"
													>
														<v-icon left x-small>mdi-check-circle</v-icon>
														{{ item_face.trainedAt ? $Helper.format_date(item_face.trainedAt, 'short') : 'Trained' }}
													</v-chip>
												</div>
											</v-expand-transition>
							            </v-card-actions>										             	
									</v-card>
								</v-item>
							</v-col>
						</v-row>	
					</v-container>
					
				</v-item-group>
			<v-divider></v-divider>
		</v-card-text>
		<v-card-actions class="text-h5">
			<strong class=" mt-2">			
				# {{  infoToFilter.tags.length }}
			</strong>
			<!-- Contador de caras entrenadas -->
			<v-chip
				v-if="trainedFacesCount > 0"
				small
				color="success"
				text-color="white"
				class="ml-2"
			>
				<v-icon left x-small>mdi-brain</v-icon>
				{{ trainedFacesCount }} Trained
			</v-chip>
			<v-spacer></v-spacer>
			<v-btn small outlined @click="triggerFileInput()" :loading="loading"> 
				<v-file-input
					dense
					multiple
				    outlined			hide-details hide-input
					ref="uploadImage"
				    prepend-icon="mdi-import"				    
				    :label  = "$ml.get('upload_images')"
				    v-model = "infoToFilter.tagsFile"								
					:loading 	= "loading"
					accept 		= "image/*"
					class 		= "mt-0"
					@change = "imageToB64(infoToFilter.tagsFile)"
					:error-messages="infoToFilter.tags.length? messageErrorUpload:[]"
				></v-file-input>
				<!-- .zip, .rar, .7z,  -->
					 <!-- webkitdirectory  -->
				{{$ml.get('import')}}
			</v-btn>
			
			<!-- Botón CitizenFaceAPI - Solo se muestra si existe la integración -->
			<v-btn 
				v-if="citizenFaceAPIExists"
				small 
				outlined 
				color="primary"
				@click="openCitizenModal()" 
				:loading="loadingIntegrations"
				class="ml-2"
			> 
				<v-icon small class="mr-1">mdi-account-search</v-icon>
				{{ $ml.get('citizen_title') }}
			</v-btn>

			<!-- Botón Train - Para entrenar las caras seleccionadas -->
			
		</v-card-actions>
	</v-card>
		
		<!-- Modal CitizenFaceAPI -->
	<v-dialog v-model="showCitizenModal" max-width="600px">
		<v-card>
			<v-card-title class="text-h6">
				<v-icon class="mr-2">mdi-account-search</v-icon>
				{{ $ml.get('citizenface_api_integration') }}
			</v-card-title>
			
			<v-card-text>
				<div class="pa-4">
					<p class="text-h6 mb-4 text-center">{{ $ml.get('citizen_query_title') }}</p>
					
					<!-- Campo de texto para ID -->
					<v-text-field
						v-model="citizenId"
						:label="$ml.get('citizen_id_label')"
						:placeholder="$ml.get('citizen_id_placeholder')"
						outlined
						dense
						class="mb-4"
						:rules="[v => !!v || $ml.get('citizen_id_required')]"
						required
					></v-text-field>
					
					<!-- Botón de consulta -->
					<div class="text-center">
						<v-btn
							color="primary"
							@click="consultarCiudadano()"
							:loading="loadingCitizenQuery"
							:disabled="!citizenId || !citizenIntegration"
							class="mb-4"
						>
							<v-icon left>mdi-magnify</v-icon>
							{{ $ml.get('consult') }}
						</v-btn>
					</div>
					
					<!-- Resultado de la consulta -->
					<v-expand-transition>
						<div v-if="citizenResult">
							<v-divider class="my-4"></v-divider>
							<div class="text-center">
								<p class="text-h6 mb-2">{{ $ml.get('query_result_title') }}</p>
								<v-alert
									:type="citizenResult.success ? 'success' : 'error'"
									outlined
									class="mb-3"
								>
									{{ citizenResult.message }}
								</v-alert>
								
								<!-- Mostrar datos del ciudadano si la consulta fue exitosa -->
								<div v-if="citizenResult.success && citizenResult.image" class="text-left">
									<v-card outlined class="pa-3">
										<div class="text-center">
											<h6 class="mb-3">Citizen Image</h6>
											<v-img
												:src="'data:image/jpeg;base64,' + citizenResult.image"
												alt="Imagen del ciudadano"
												max-width="200"
												max-height="250"
												contain
												class="mx-auto"
											></v-img>
											
											<!-- Información del ciudadano -->
											<div class="mt-4 text-left">
												<v-list dense>
													<v-list-item dense v-if="citizenResult.firstname">
														<v-list-item-icon class="mr-2">
															<v-icon small>mdi-account</v-icon>
														</v-list-item-icon>
														<v-list-item-content>
															<v-list-item-title class="text-caption">Name: {{ citizenResult.firstname }}</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
													
													<v-list-item dense v-if="citizenResult.gender">
														<v-list-item-icon class="mr-2">
															<v-icon small>mdi-gender-male-female</v-icon>
														</v-list-item-icon>
														<v-list-item-content>
															<v-list-item-title class="text-caption">Gender: {{ citizenResult.gender }}</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
													
													<v-list-item dense v-if="citizenResult.birthDate">
														<v-list-item-icon class="mr-2">
															<v-icon small>mdi-calendar</v-icon>
														</v-list-item-icon>
														<v-list-item-content>
															<v-list-item-title class="text-caption">Birth Date: {{ citizenResult.birthDate }}</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
													
													<v-list-item dense v-if="citizenResult.civilId">
														<v-list-item-icon class="mr-2">
															<v-icon small>mdi-card-account-details</v-icon>
														</v-list-item-icon>
														<v-list-item-content>
															<v-list-item-title class="text-caption">Civil ID: {{ citizenResult.civilId }}</v-list-item-title>
														</v-list-item-content>
													</v-list-item>
												</v-list>
											</div>
											
											<!-- Botones de acción para la imagen -->
											<div class="mt-4">
												<v-btn
													color="success"
													outlined
													@click="addToFaces()"
													:loading="loadingAddToFaces"
													:disabled="isCitizenAlreadyImported"
													class="mr-2"
												>
													<v-icon left>mdi-import</v-icon>
													{{ isCitizenAlreadyImported ? 'Already Imported' : 'Import' }}
												</v-btn>
												
												<v-btn
													color="primary"
													outlined
													@click="trainCitizen()"
													:loading="loadingTraining"
													:disabled="!citizenResult || !citizenResult.image"
												>
													<v-icon left>mdi-brain</v-icon>
													Train
												</v-btn>
											</div>
										</div>
									</v-card>
								</div>
								
								<!-- Lista de ciudadanos agregados -->
								<div v-if="addedCitizens.length > 0" class="mt-4">
									<v-divider class="my-4"></v-divider>
									<h6 class="mb-3">Added Citizens</h6>
									<v-list dense>
										<v-list-item
											v-for="(citizen, index) in addedCitizens"
											:key="index"
											class="mb-2"
										>
											<v-list-item-avatar>
												<v-img
													:src="'data:image/jpeg;base64,' + citizen.image"
													width="40"
													height="40"
													contain
												></v-img>
											</v-list-item-avatar>
											<v-list-item-content>
												<v-list-item-title>{{ citizen.firstname || 'Unknown' }}</v-list-item-title>
												<v-list-item-subtitle>
													ID: {{ citizen.citizenId }} | 
													{{ citizen.type === 'faces' ? 'Added to Faces' : 'Trained' }}
												</v-list-item-subtitle>
											</v-list-item-content>
											<v-list-item-action>
												<v-btn
													icon
													small
													color="error"
													@click="removeCitizen(index)"
												>
													<v-icon>mdi-delete</v-icon>
												</v-btn>
											</v-list-item-action>
										</v-list-item>
									</v-list>
								</div>
							</div>
						</div>
					</v-expand-transition>
					
					<!-- Información de la integración -->
					<v-alert type="info" outlined class="mt-4">
						<strong>{{ $ml.get('endpoint') }}:</strong> {{ citizenIntegration ? citizenIntegration.ip_address : $ml.get('not_configured') }}
					</v-alert>
				</div>
			</v-card-text>
			
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn 
					color="error" 
					outlined
					@click="showCitizenModal = false"
				>
					{{ $ml.get('close') }}
				</v-btn>
			</v-card-actions>
		</v-card>
		</v-dialog>
	</div>
</template>
<script type="text/javascript">
	export default{
		name: "SidebarFaces",
		props:["infoToFilter"],
		data: ()=>({
			loading:false,
			messageErrorUpload: [],
			citizenFaceAPIExists: false,
			showCitizenModal: false,
			loadingIntegrations: false,
			citizenId: '',
			citizenResult: null,
			loadingCitizenQuery: false,
			citizenIntegration: null,
			loadingAddToFaces: false,
			loadingTraining: false,
			loadingTrainSelected: false,
			addedCitizens: [],
		}),
		computed: {
			// Check if current citizen is already imported
			isCitizenAlreadyImported() {
				if (!this.citizenId || !this.infoToFilter.tags) {
					return false;
				}
				return this.infoToFilter.tags.some(face => face.citizenId === this.citizenId);
			},
			// Calcular el número de caras entrenadas
			trainedFacesCount() {
				return this.infoToFilter.tags.filter(face => face.isTrained).length;
			}
		},
		methods:{
			triggerFileInput(){				
				this.$refs.uploadImage.$el.querySelector('input[type="file"]').click();
			},
			deleteFaceItem(item){
				this.infoItem=item;
				const idx = this.infoToFilter.tags.indexOf(item);
				if(idx>=0){
					this.infoToFilter.tags.splice(idx,1);
					this.infoToFilter.tagsFile.splice(idx,1);
					const idx2=this.infoToFilter.tagsSelected.indexOf(item)					
					if(idx2>=0){
						this.infoToFilter.tagsSelected.splice(idx2,1)
					}
				}
			},
			async imageToB64(files){
				try{
					if (files && files.length > 0) {
						// this.infoToFilter.tags = [];	
						this.loading=true;
						let tempImgs = []				
						// add images b64
						for(const idx_fil in files){						
							if (files[idx_fil]) {
								const b64 = await this.$Helper.file_to_b64(files[idx_fil]) 
								if (b64) {
									tempImgs.push({imgBase64 : b64, isActive:true })// imgBase64
								}
							}
						}// for 1
						let tempText=[];
						let count=0;
						let count1=0;
						// validator
						for(const idxValid in tempImgs){												
							const res = await this.$Helper.validateFaceUpload([tempImgs[idxValid]])											
							if(res && res.data && res.data.length){
								// tempImgs.forEach((img, idx)=>{
									// tempImgs[idxValid]
									const item = res.data[0];
									if(item && item.bbox){
										const temp={
											imgBase64    : tempImgs[idxValid].imgBase64,
											key 		: idxValid + 1,//idx_fil
											isValid 	: true,
											uuid 		: this.$Helper.generateUUIDv4(), 
											name : "FACE "+idxValid,
										}
										this.infoToFilter.tags.unshift(temp)															
										count++;
										this.infoToFilter.tagsSelected.unshift(temp)
									}else{
										count1++;
										this.infoToFilter.tags.unshift({
											imgBase64    : tempImgs[idxValid].imgBase64,
											key 		: idxValid + 1, //idx_fil
											isInvalid 	: true,
											msg 		: item?.msg,
											uuid 		: this.$Helper.generateUUIDv4(), 
											name : "FACE "+idxValid,
										})						
										if(item?.msg){
											if(item.msg == "Cant find face in input"){
												tempText.unshift(this.$ml.get("Cant find face in input"))
											}else{
												tempText.unshift(item.msg) 
											}
										}
									}
								// })														
							}									
							
						} // for

						const tempError=`${this.$ml.get("validated_images")} : ${count} ; 
							${this.$ml.get("invalid_images")} : ${count1} ; 
							${this.$ml.get("error")}: ${tempText?tempText.join(","):''}`
						this.$EventBus.$emit("notifications_modal",{ type: count ? "success" : "warning", direction: " ", message: tempError })
						// this.handleDirectory(files);
						if(count1){
							this.messageErrorUpload=[tempError]
						}else{
							this.messageErrorUpload=[];
						}

						this.loading=false	
						
					}
				}catch(error){
					console.warn("Error convert to b64 ", error)
				}finally{
					this.loading=false;
				}
			},			
		    handleDirectory(event) {
		      	const directoryFiles = event.target.files; // Todos los archivos en la carpeta
		      	this.infoToFilter.tagsFile = [...this.infoToFilter.tagsFile, ...Array.from(directoryFiles)];
		    },
		    
		    // Verificar si existe integración CitizenFaceAPI
		    async checkCitizenFaceAPIIntegration() {
		    	try {
		    		this.loadingIntegrations = true;
		    		const api = this.$URL + '/api/v1/cloud/?page=1';
		    		const response = await this.$axios.get(api);
		    		
		    		if (response.data && response.data.rows) {
		    			// Buscar si existe alguna integración de tipo CitizenFaceAPI
		    			const citizenIntegration = response.data.rows.find(
		    				integration => integration.type_integrate === 'CitizenFaceAPI'
		    			);
		    			this.citizenFaceAPIExists = !!citizenIntegration;
		    			this.citizenIntegration = citizenIntegration || null;
		    		}
		    	} catch (error) {
		    		console.warn('Error checking CitizenFaceAPI integration:', error);
		    		this.citizenFaceAPIExists = false;
		    		this.citizenIntegration = null;
		    	} finally {
		    		this.loadingIntegrations = false;
		    	}
		    },
		    
		    // Abrir modal CitizenFaceAPI
		    openCitizenModal() {
		    	this.showCitizenModal = true;
		    	// Limpiar datos del formulario
		    	this.citizenId = '';
		    	this.citizenResult = null;
		    	this.addedCitizens = []; // Limpiar la lista de ciudadanos agregados
		    },
		    
		    // Consultar ciudadano usando CitizenFace API
		    async consultarCiudadano() {
		    	if (!this.citizenId || !this.citizenIntegration) {
		    		this.$EventBus.$emit("notifications_modal", {
		    			type: "warning",
		    			message: this.$ml.get('citizen_id_required_integration')
		    		});
		    		return;
		    	}
		    	
		    	// Función auxiliar para hacer la consulta
		    	const hacerConsulta = async (token) => {
		    		const baseUrl = this.citizenIntegration.ip_address;
		    		const endpoint = '/asapZurag/checkCitizen';
		    		const url = `${baseUrl}${endpoint}?regnum=${this.citizenId}`;
		    		
		    		const response = await this.$axios.get(url, {
		    			headers: {
		    				'Authorization': `Bearer ${token}`,
		    				'Content-Type': 'application/json'
		    			}
		    		});
		    		
		    		return { response, url };
		    	};
		    	
		    	// Función auxiliar para procesar respuesta exitosa
		    	const procesarRespuestaExitosa = (response) => {
		    		console.log('Procesando respuesta:', response);
		    		console.log('Response.data:', response.data);
		    		console.log('Response.data.data:', response.data?.data);
		    		console.log('Response.data.data.image existe:', !!response.data?.data?.image);
		    		console.log('Tipo de response.data.data.image:', typeof response.data?.data?.image);
		    		console.log('Longitud de response.data.data.image:', response.data?.data?.image?.length);
		    		
		    		// La API devuelve la imagen en response.data.data.image
		    		if (response.data && response.data.data && response.data.data.image) {
		    			console.log('✅ Imagen encontrada, procesando...');
		    			
		    			// Extraer información adicional del ciudadano
		    		const ciudadanoData = response.data.data;
		    		this.citizenResult = {
		    			success: true,
		    			message: this.$ml.get('citizen_query_success') || 'Consulta exitosa',
		    			image: ciudadanoData.image,
		    			firstname: ciudadanoData.firstname || ciudadanoData.firstName || '',
		    			lastname: ciudadanoData.lastname || ciudadanoData.lastName || '',
		    			gender: ciudadanoData.gender || '',
		    			birthDate: ciudadanoData.birthDateAsText || ciudadanoData.birthDate || '',
		    			civilId: ciudadanoData.civilId || '',
		    			address: ciudadanoData.addressStreetName || ciudadanoData.address || ''
		    			};
		    			
		    			this.$EventBus.$emit("notifications_modal", {
		    				type: "success",
		    				message: this.$ml.get('citizen_query_success') || 'Consulta exitosa'
		    			});
		    			
		    			return true;
		    		} else {
		    			console.log('❌ No se encontró imagen en la respuesta');
		    			console.log('response.data:', response.data);
		    			console.log('response.data.data:', response.data?.data);
		    		// Verificar si hay otros campos útiles en la respuesta
		    		if (response.data && response.data.data) {
		    			console.log('Campos disponibles en data:', Object.keys(response.data.data));
		    		}
		    		this.citizenResult = {
		    			success: false,
		    			message: 'La respuesta no contiene imagen del ciudadano',
		    			image: null
		    		};
		    		
		    		this.$EventBus.$emit("notifications_modal", {
		    			type: "warning",
		    			message: 'La respuesta no contiene imagen del ciudadano'
		    		});
		    		
		    		return false;
		    		}
		    	};
		    	
		    	try {
		    		this.loadingCitizenQuery = true;
		    		this.citizenResult = null;
		    		
		    		// Obtener el token actual
		    		let token = this.citizenIntegration.password;
		    		
		    		// Primer intento con el token actual
		    		try {
		    			const { response, url } = await hacerConsulta(token);
		    			if (procesarRespuestaExitosa(response)) {
		    				return; // Éxito en el primer intento
		    		}
		    		} catch (firstError) {
		    			console.log('Primer intento falló:', firstError.message);
		    			
		    			// Verificar si es un error de token (401, 403, o mensaje específico)
		    			const isTokenError = firstError.response && (
		    				firstError.response.status === 401 || 
		    				firstError.response.status === 403 ||
		    				firstError.response.data?.message?.toLowerCase().includes('token') ||
		    				firstError.response.data?.message?.toLowerCase().includes('jwt') ||
		    				firstError.response.data?.message?.toLowerCase().includes('unauthorized')
		    			);
		    			
		    			if (isTokenError) {
		    				console.log('Error de token detectado, intentando renovar...');
		    				
		    				try {
		    					// Renovar el token
		    					await this.refreshToken();
		    					
		    					// Obtener el nuevo token
		    					token = this.citizenIntegration.password;
		    					
		    					// Segundo intento con el nuevo token
		    					console.log('Token renovado, reintentando consulta...');
		    					const { response: retryResponse } = await hacerConsulta(token);
		    					
		    					if (procesarRespuestaExitosa(retryResponse)) {
		    						return; // Éxito en el reintento
		    					}
		    					
		    				} catch (refreshError) {
		    					console.error('Error renovando token:', refreshError);
		    					// Continuar con el manejo de error original
		    				}
		    			}
		    			
		    		}
		    		
		    	} catch (error) {
		    		console.error('Error general en consulta:', error);
		    		
		    		// Procesar error final
		    		this.citizenResult = {
		    			success: false,
		    			message: error.response?.data?.message || error.message || this.$ml.get('citizen_query_error') || 'Error en la consulta',
		    			image: null
		    		};
		    		
		    		this.$EventBus.$emit("notifications_modal", {
		    			type: "error",
		    			message: this.$ml.get('citizen_query_error') || 'Error en la consulta'
		    		});
		    	} finally {
		    		this.loadingCitizenQuery = false;
		    	}
		    },
		    
		    // Manejar acción del modal CitizenFaceAPI (mantener para compatibilidad)
		    handleCitizenAction() {
		    	// Este método se mantiene por compatibilidad pero ya no se usa
		    	console.log('Método handleCitizenAction mantenido por compatibilidad');
		    },
			
			// Refrescar token de CitizenFace API
			async refreshToken() {
				if (!this.citizenIntegration) {
					this.$EventBus.$emit("notifications_modal", {
						type: "warning",
						message: this.$ml.get('citizen_integration_not_configured')
					});
					return;
				}

				try {
					this.loadingTokenRefresh = true;
					const baseUrl = this.citizenIntegration.ip_address;
					const endpoint = '/asapZurag/token';
					const url = `${baseUrl}${endpoint}`;

					// Credenciales para autenticación básica
					const username = 'AsapZurag';
					const password = 'c~G/%Yo_mhRUxaYo!tc5pcHu%|wJc~G/%Yo_mhRUxaYo!tc5pcHu%|wJ';
					
					// Crear token base64 para Basic Auth
					const basicAuth = btoa(`${username}:${password}`);

					const response = await this.$axios.get(url, {
						headers: {
							'Authorization': `Basic ${basicAuth}`,
							'Content-Type': 'application/json'
						}
					});

					// Verificar que la respuesta contenga el token
					if (response.data && response.data.token) {
						// Actualizar el token en la integración
						this.citizenIntegration.password = response.data.token;
						
						this.$EventBus.$emit("notifications_modal", {
							type: "success",
							message: this.$ml.get('token_refreshed_success') || 'Token actualizado exitosamente'
						});
						
						console.log('Token actualizado:', response.data.token);
					} else {
						throw new Error('Respuesta no contiene token válido');
					}

				} catch (error) {
					console.error('Error refreshing token:', error);
					this.$EventBus.$emit("notifications_modal", {
						type: "error",
						message: error.response?.data?.message || error.message || this.$ml.get('token_refreshed_error') || 'Error al refrescar el token'
					});
				}
			},

			// Add citizen image to faces (same as import button)
			async addToFaces() {
				if (!this.citizenResult || !this.citizenResult.image) {
					this.$EventBus.$emit("notifications_modal", {
						type: "warning",
						message: this.$ml.get('citizen_image_required_add') || 'Citizen image is required to add to faces'
					});
					return;
				}

				// Check if citizen is already imported
				const existingCitizen = this.infoToFilter.tags.find(face => face.citizenId === this.citizenId);
				if (existingCitizen) {
					this.$EventBus.$emit("notifications_modal", {
						type: "warning",
						message: this.$ml.get('citizen_already_imported') || `Citizen ${this.citizenId} is already imported to faces`
					});
					return;
				}

				this.loadingAddToFaces = true;
				console.log('🚀 Starting addToFaces function...');
				
				try {
					console.log('📸 Creating face object...');
					
					// Extract base64 without data:image prefix for validation
					let base64Image = this.citizenResult.image;
					if (base64Image.startsWith('data:image/')) {
						base64Image = base64Image.split(',')[1];
					}
					
					console.log('🔍 Base64 image length:', base64Image.length);
					
					// Create face object exactly like imageToB64 function
					const tempImg = { imgBase64: base64Image, isActive: true };
					
					console.log('🔍 Starting face validation...');
					// Validate face using the same helper as import button
					const res = await this.$Helper.validateFaceUpload([tempImg]);
					console.log('✅ Face validation response:', res);
					
					if (res && res.data && res.data.length) {
						const item = res.data[0];
						console.log('📋 Validation item:', item);
						
						if (item && item.bbox) {
							console.log('✅ Face validation successful, creating face object...');
							// Face validation successful - create face object exactly like import
							const temp = {
								imgBase64: `data:image/jpeg;base64,${base64Image}`, // Add data prefix for display
								key: this.infoToFilter.tags.length + 1,
								isValid: true,
								uuid: this.$Helper.generateUUIDv4(),
								name: `CITIZEN_${this.citizenId}`,
								// Additional citizen info
								citizenId: this.citizenId,
								firstname: this.citizenResult.firstname || 'Unknown',
								lastname: this.citizenResult.lastname || '',
								gender: this.citizenResult.gender || '',
								birthDate: this.citizenResult.birthDate || '',
								civilId: this.citizenResult.civilId || ''
							};

							console.log('📝 Face object created:', temp);
							console.log('📊 Current tags count:', this.infoToFilter.tags.length);

							// Add to faces list exactly like import button
							this.infoToFilter.tags.unshift(temp);
							this.infoToFilter.tagsSelected.unshift(temp);

							console.log('✅ Added to faces lists. New count:', this.infoToFilter.tags.length);

							// Add to added citizens list
							this.addedCitizens.push({
								image: this.citizenResult.image, // Keep original with prefix for display
								firstname: this.citizenResult.firstname || 'Unknown',
								lastname: this.citizenResult.lastname || '',
								citizenId: this.citizenId,
								type: 'faces'
							});

							console.log('✅ Added to citizens list. Count:', this.addedCitizens.length);

							this.$EventBus.$emit("notifications_modal", {
								type: "success",
								message: this.$ml.get('citizen_added_to_faces_success') || 'Citizen added to faces successfully'
							});

							// Clear the citizen result
							this.citizenResult = null;
							console.log('🧹 Citizen result cleared');

						} else {
							console.log('❌ Face validation failed - no bbox:', item);
							// Face validation failed
							this.$EventBus.$emit("notifications_modal", {
								type: "warning",
								message: item?.msg || 'Face validation failed - no face detected'
							});
						}
					} else {
						console.log('❌ Face validation response invalid:', res);
						this.$EventBus.$emit("notifications_modal", {
							type: "warning",
							message: 'Face validation failed - invalid response'
						});
					}

				} catch (error) {
					console.error('💥 Error in addToFaces:', error);
					this.$EventBus.$emit("notifications_modal", {
						type: "error",
						message: error.message || this.$ml.get('citizen_added_to_faces_error') || 'Error adding citizen to faces'
					});
				} finally {
					console.log('🏁 Finishing addToFaces function...');
					this.loadingAddToFaces = false;
				}
			},

			// Train model with citizen image
			async trainCitizen() {
				if (!this.citizenResult || !this.citizenResult.image) {
					this.$EventBus.$emit("notifications_modal", {
						type: "warning",
						message: this.$ml.get('citizen_image_required_train') || 'Citizen image is required for training'
					});
					return;
				}

				this.loadingTraining = true;
				try {
					// First try to use the standard training endpoint if the citizen is already in faces
					const existingFace = this.infoToFilter.tags.find(face => face.citizenId === this.citizenId);
					
					if (existingFace && existingFace.isValid) {
						// Use standard training endpoint
						console.log('🚀 Using standard training endpoint for citizen face');
						
						const api = this.$URL + "/api/v1/face/train";
						const info_up = {
							deviceId: this.$route.params.deviceId || null,
							name: existingFace.name || `CITIZEN_${this.citizenId}`,
							faceUUID: existingFace.uuid,
							ids: [existingFace.key || existingFace.uuid]
						};

						const response = await this.$axios.post(api, info_up);
						
						if (response && response.data) {
							// Mark face as trained
							existingFace.isTrained = true;
							existingFace.trainedAt = new Date().toISOString();

							// Add to added citizens list
							this.addedCitizens.push({
								image: this.citizenResult.image,
								firstname: this.citizenResult.firstname || 'Unknown',
								lastname: this.citizenResult.lastname || '',
								citizenId: this.citizenId,
								type: 'train'
							});

							this.$EventBus.$emit("notifications_modal", {
								type: "success",
								message: this.$ml.get('citizen_trained_success') || 'Citizen training completed successfully using standard endpoint'
							});

							// Clear the citizen result
							this.citizenResult = null;
							return;
						}
					}

					// Fallback to CitizenFace API if standard endpoint fails or citizen not in faces
					console.log('🔄 Falling back to CitizenFace API for training');
					
					const baseUrl = this.citizenIntegration.ip_address;
					const endpoint = '/asapZurag/trainModel';
					const url = `${baseUrl}${endpoint}`;

					const response = await this.$axios.post(url, {
						image: this.citizenResult.image,
						firstname: this.citizenResult.firstname || 'Unknown',
						lastname: this.citizenResult.lastname || '',
						regnum: this.citizenId,
						type: 'train'
					}, {
						headers: {
							'Authorization': `Bearer ${this.citizenIntegration.password}`,
							'Content-Type': 'application/json'
						}
					});

					if (response.data && response.data.success) {
						// Add to added citizens list
						this.addedCitizens.push({
							image: this.citizenResult.image,
							firstname: this.citizenResult.firstname || 'Unknown',
							lastname: this.citizenResult.lastname || '',
							citizenId: this.citizenId,
							type: 'train'
						});

						this.$EventBus.$emit("notifications_modal", {
							type: "success",
							message: this.$ml.get('citizen_trained_success') || 'Citizen training completed successfully using CitizenFace API'
						});

						// Clear the citizen result
						this.citizenResult = null;
					} else {
						this.$EventBus.$emit("notifications_modal", {
							type: "error",
							message: response.data?.message || this.$ml.get('citizen_trained_error') || 'Error training citizen'
						});
					}
				} catch (error) {
					console.error('Error training citizen:', error);
					this.$EventBus.$emit("notifications_modal", {
						type: "error",
						message: error.response?.data?.message || error.message || this.$ml.get('citizen_trained_error') || 'Error training citizen'
					});
				} finally {
					this.loadingTraining = false;
				}
			},

			// Remove citizen from added citizens list
			removeCitizen(index) {
				const citizen = this.addedCitizens[index];
				const type = citizen.type;
				const id = citizen.citizenId;

				this.$EventBus.$emit("notifications_modal", {
					type: "info",
					message: this.$ml.get('citizen_delete_confirm', { id: id, type: type }) || `Confirm deletion of ${type} citizen ${id}`
				});

				this.$EventBus.$emit("confirm_action", {
					title: this.$ml.get('confirm_delete_title') || 'Confirm Deletion',
					message: this.$ml.get('citizen_delete_confirm', { id: id, type: type }) || `Are you sure you want to delete this ${type} citizen?`,
					callback: async () => {
						try {
							// Remove from added citizens list
							this.addedCitizens.splice(index, 1);

							// If it was added to faces, also remove from faces list
							if (type === 'faces') {
								const faceIndex = this.infoToFilter.tags.findIndex(face => face.citizenId === id);
								if (faceIndex !== -1) {
									this.infoToFilter.tags.splice(faceIndex, 1);
									
									// Also remove from selected tags
									const selectedIndex = this.infoToFilter.tagsSelected.findIndex(face => face.citizenId === id);
									if (selectedIndex !== -1) {
										this.infoToFilter.tagsSelected.splice(selectedIndex, 1);
									}
								}
							}

							this.$EventBus.$emit("notifications_modal", {
								type: "success",
								message: this.$ml.get('citizen_delete_success', { id: id, type: type }) || `${type} citizen ${id} deleted successfully`
							});
						} catch (error) {
							console.error('Error removing citizen:', error);
							this.$EventBus.$emit("notifications_modal", {
								type: "error",
								message: error.message || this.$ml.get('citizen_delete_error', { id: id, type: type }) || 'Error removing citizen'
							});
						}
					}
				});
			},

			// Train selected faces using the /api/v1/face/train endpoint
			async trainSelectedFaces() {
				// Check if there are selected faces
				if (!this.infoToFilter.tagsSelected || this.infoToFilter.tagsSelected.length === 0) {
					this.$EventBus.$emit("notifications_modal", {
						type: "warning",
						message: this.$ml.get('face_selection_required') || 'Please select faces to train'
					});
					return;
				}

				// Check if selected faces are valid
				const validFaces = this.infoToFilter.tagsSelected.filter(face => face.isValid);
				if (validFaces.length === 0) {
					this.$EventBus.$emit("notifications_modal", {
						type: "warning",
						message: this.$ml.get('valid_faces_required') || 'Please select valid faces to train'
					});
					return;
				}

				this.loadingTrainSelected = true;
				try {
					// Prepare data for training
					const api = this.$URL + "/api/v1/face/train";
					const info_up = {
						deviceId: this.$route.params.deviceId || null, // Get device ID from route if available
						name: validFaces[0]?.name || "Trained Faces", // Use first face name or default
						faceUUID: validFaces[0]?.uuid || null, // Use first face UUID if available
						ids: validFaces.map(face => face.key || face.uuid).filter(id => id) // Extract IDs from valid faces
					};

					console.log('🚀 Training faces with data:', info_up);

					const response = await this.$axios.post(api, info_up);
					
					if (response && response.data) {
						console.log('✅ Training response:', response.data);
						
						// Handle successful training
						this.$EventBus.$emit("notifications_modal", {
							type: "success",
							message: this.$ml.get('training_faces_success') || 'Faces training completed successfully'
						});

						// Update face status to indicate they are trained
						validFaces.forEach(face => {
							face.isTrained = true;
							face.trainedAt = new Date().toISOString();
						});

						// Clear selection after successful training
						this.infoToFilter.tagsSelected = [];

						// Emit event to notify parent components about training completion
						this.$EventBus.$emit("faces_training_completed", {
							trainedFaces: validFaces,
							response: response.data
						});

					} else {
						throw new Error('Invalid response from training API');
					}

				} catch (error) {
					console.error('💥 Error training faces:', error);
					
					let errorMessage = this.$ml.get('training_faces_error') || 'Error training faces';
					if (error.response?.data?.message) {
						errorMessage = error.response.data.message;
					} else if (error.message) {
						errorMessage = error.message;
					}

					this.$EventBus.$emit("notifications_modal", {
						type: "error",
						message: errorMessage
					});
				} finally {
					this.loadingTrainSelected = false;
				}
			}
			
		}, // methods
		
		// Lifecycle hooks
		mounted() {
			// Verificar si existe integración CitizenFaceAPI al montar el componente
			this.checkCitizenFaceAPIIntegration();
		}
	}
</script>